import { render, staticRenderFns } from "./ActivationBriefOrdersListView.vue?vue&type=template&id=51ac9ad5&"
import script from "./ActivationBriefOrdersListView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrdersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports